export default [
  {
    path: '/express',
    name: 'express',
    component: () => import('@/views/outbox/express/Express.vue'),
    meta: {
      pageTitle: 'Express SMS',
      breadcrumb: [
        {
          text: 'Compose',
          active: true,
        },
      ],
    },
  },
]
